import { BookerRouteSettings } from '@chilipiper/api-type-def'
import { defaultLocale, Locale } from '@chilipiper/locale'

export const redirect = (reference: any, routerData: Record<string, unknown>) => {
  try {
    if (reference?.push) {
      reference.push(routerData)
    } else {
      reference.context.router.push(routerData)
    }
  } catch (err) {
    // IE 11 issue
    if ((err as Error).message !== "Object doesn't support this action") {
      throw err
    }
  }
}

// This is used to change urls for redirects returned by BE,
// to prevent render staging content on local
export const transformUrlForLocal = (url: string) => {
  const isLocal = window.location.origin.includes('chilipiper.team')

  if (!isLocal) {
    return url
  }

  const urlLink = new URL(url)
  const domain = urlLink.host.substring(0, urlLink.host.indexOf('.'))

  const properUrlForLocal = `${window.location.origin}${urlLink.pathname}${urlLink.search}&domain=${domain}`

  return properUrlForLocal
}

export const removeParam = (link: string, key: string) => {
  const url = new URL(link)
  url.searchParams.delete(key)
  return url.toString()
}

export const isMeetingApprovalFlow = (meetingApprovalFlow: boolean, isSuggestedTimes: boolean) => {
  return meetingApprovalFlow && !isSuggestedTimes
}

export const getLocalisedRouteSettings = (route: BookerRouteSettings | undefined, locale: Locale) =>
  route?.uiSettings?.wordingStyle[locale] || route?.uiSettings.wordingStyle[defaultLocale]
